import { Box, CircularProgress, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './useStyles'

import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../redux/actions/app'
import { useDispatch } from 'react-redux'
import { logEvent } from '../../../utils/LogEvents'
import { updateGlobalNotification } from '../../../redux/actions/GlobalNotification'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 225,
  bgcolor: 'white',
  p: 3,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const DeleteNotification = ({ item, openModal, handleClose }) => {
  const classes = useStyles()
  const [showCircularProgress, setShowCircularProgress] = useState(false)

  const dispatch = useDispatch()

  const disabledNotificacion = async () => {
    setShowCircularProgress(true)
    try {
      const body = {
        notificationId: item,
        isActive: false
      }

      const response = await dispatch(updateGlobalNotification(body))
      logEvent('CGI - disableApplicationInstanceAppModule', {
        body: {
          body
        },
        response: response
      })

      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Deshabilitación exitosa'))
      setTimeout(() => {
        handleClose()
        window.location.href = '/globalNotification'
      }, 1000)
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar('Ocurrió un error en un servicio de: eAuthzAPI')
      )
    }
    setShowCircularProgress(false)
  }

  return (
    <>
      <Modal open={openModal} onClose={handleClose}>
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={handleClose}
            />
          </div>

          <div>
            <Typography sx={{ color: '#263057', fontSize: '1.3em' }}>
              Eliminar notificación
            </Typography>
          </div>
          <Typography
            sx={{
              color: '#263057',
              fontFamily: 'Roboto',
              marginTop: '5%'
            }}
          >
            ¿Esta seguro de que desea eliminar la notificación?
          </Typography>

          <Box className={classes.buttons} style={{ marginLeft: '45%' }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              disabledNotification={disabledNotificacion}
            />

            <ButtonClose handleClose={handleClose} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm ({ showCircularProgress, disabledNotification }) {
  const classes = useStyles()
  const [isProgressComplete, setProgressComplete] = useState(false)

  const handleButtonClick = () => {
    if (!isProgressComplete && !showCircularProgress) {
      disabledNotification()
      setProgressComplete(true)
    }
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className={`${classes.confirmButton} ${
          isProgressComplete ? classes.disabledButton : ''
        }`}
        disabled={isProgressComplete || showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress
          ? (
          <CircularProgress size="1.5rem" color="inherit" />
            )
          : (
          <Typography className={classes.confirmButtonTypography}>
            Eliminar
          </Typography>
            )}
      </button>
    </div>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
